var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrumpyGhost(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "75px",
    height: "99px",
    viewBox: "0 0 75 99",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "VB--404-Copy-6",
    transform: "translate(-689.000000, -358.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(689.985500, 358.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6507049,0 C16.4425159,0 5.90889613e-07,14.7831784 5.90889613e-07,32.9520089 L5.90889613e-07,89.3795445 C-0.0018584101,95.0406892 4.38306013,98 8.71591008,98 C13.04876,98 17.4336786,95.0390173 17.4336786,89.3795445 C17.4336786,85.589286 20.0594228,83.8939521 22.662852,83.8939521 C25.2662811,83.8939521 27.8920254,85.589286 27.8920254,89.3795445 C27.8920254,95.0406892 32.2769439,98 36.6097939,98 C40.9426439,98 45.3275624,95.0390173 45.3275624,89.3795445 C45.3275624,85.589286 47.9533067,83.8939521 50.5567358,83.8939521 C53.160165,83.8939521 55.7859092,85.589286 55.7859092,89.3795445 C55.7859092,95.0406892 60.1708278,98 64.5036777,98 C68.8365277,98 73.2214462,95.0390173 73.2214462,89.3795445 L73.2604976,32.9887913 C73.2604976,14.9169325 56.9927846,0.2106628 36.9370821,0.0518297364 C36.8385237,0.0367823936 36.7529825,0 36.6507049,0 Z",
    id: "Fill-1",
    fill: "#506C94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9122192,19.642123 C15.8698626,14.8180463 20.3486873,11.4954884 26.3486934,9.67444928",
    id: "Path-5",
    stroke: "#91A0B4",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 24.0304563,
    cy: 39.8306485,
    r: 5.33064846
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "#FFFFFF",
    cx: 49.0309522,
    cy: 39.8306485,
    r: 5.33064846
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5082673,60.4403642 C34.8405131,57.9438334 41.5885007,59.2313095 46.7522303,64.3027924",
    id: "Path-6",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrumpyGhost);
export default __webpack_public_path__ + "static/media/frumpy-ghost.e93af0fe74bbdb25f7104f05f32c32b0.svg";
export { ForwardRef as ReactComponent };